import type { TemplateOnlyComponent as TOC } from '@ember/component/template-only';

type DynamicRateRangesRateRow = {
  isDefault: boolean;
};

interface SettingsRecommendationsDynamicRateRangesTdRateSignature {
  Args: {
    row: DynamicRateRangesRateRow;
    value: string;
  };
}

const SettingsRecommendationsDynamicRateRangesTdRate = <template>
  {{#if @row.isDefault}}
    {{@value}}
  {{else}}
    {{! Visually empty so the group still reads as one spanned cell;
      screen readers get the rate name instead of a blank cell. }}
    <span class="sr-only">{{@value}}</span>
  {{/if}}
</template> satisfies TOC<SettingsRecommendationsDynamicRateRangesTdRateSignature>;

export default SettingsRecommendationsDynamicRateRangesTdRate;
